import App from 'app/app'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { CssBaseline } from '@mui/material'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { apolloClient } from './apollo-client'
import { wagmiConfig } from './wagmi-config'

// TODO: Remove this once the app is ready for production
// registerSW()

const container = document.querySelector('#root')
if (container) {
  const root = createRoot(container)
  const queryClient = new QueryClient()

  root.render(
    <StrictMode>
      <ApolloProvider client={apolloClient}>
        <WagmiProvider config={wagmiConfig}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <CssBaseline />
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        </WagmiProvider>
      </ApolloProvider>
    </StrictMode>
  )
}
